import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const GroupLabel = styled.div({
  textTransform: 'initial',
  font: token('font.body.small'),
  marginBottom: token('space.100'),
});
